module.exports = __webpack_public_path__ + "static/why-jenga-one-1c289f419c4fa236c1288910d68aa153.svg";